import { render, staticRenderFns } from "./detailFilesDetail.vue?vue&type=template&id=1d2b7a1c&"
import script from "./detailFilesDetail.vue?vue&type=script&lang=js&"
export * from "./detailFilesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports